import Iframe from '@shared/modules/utils/Iframe';
import { I18n } from '@shared/modules/utils/LangUtil';
import EventService from '@shared/services/EventService';
import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';


class TermConditionPopup extends Component {
  constructor() {
    super();
    this.state = {
      title: 'Terms and Conditions',
      termUrl : "/pub/terms?lang="
    };
  }
  onClickOk = () => {
    EventService.publish('modal.hide');
    this.props.saveCallback ? this.props.saveCallback() : "";
  }
  componentDidMount() {
    let {termUrl} = this.state
    if(this.props.termUrl) {
      termUrl = this.props.termUrl;
      this.setState({termUrl});
    }
  }
  render() {
    let lang = window.localStorage.getItem("lang");
    lang = lang ? lang.toUpperCase() : "EN";
    return (
      <div className="term-condition">
        <h1>{I18n('g.msg.terms2')}</h1>
          <Iframe url={`${this.state.termUrl}${lang}`} />
        <div className="button-wrapper">
          <button className="button ripple" onClick={this.onClickOk}>{I18n('g.lbl.ok').toUpperCase()}</button>
        </div>
      </div>
    );
  }
}

export default withRouter(TermConditionPopup);
